import { PAGE_TYPE_PRODUCT, TENANT_BE } from 'shared/consts'
import store from 'shared/store'
import { isDesktop } from 'shared/utils/deviceClassUtils'
import type { PageType } from 'types/cmsTypes'
import type { Tenant } from 'types/shopConfig'

const isBannerInserted = (addedNode: Node): boolean =>
  addedNode.nodeType === 1 &&
  (<Element>addedNode).matches('.responsive-wrapper')

const handleBannerEvents = () => {
  if (!window.AF) {
    return
  }

  window.AF('banners', 'showBanner')
}
const handleMutations = (
  mutations: MutationRecord[],
  callback: CallableFunction
) => {
  for (const mutation of mutations) {
    const banner = Array.from(mutation.addedNodes).find(isBannerInserted)

    if (banner) {
      callback()
      break
    }
  }
}
const observeBanner = (callback: CallableFunction) => {
  // eslint-disable-next-line prefer-const
  let observer: MutationObserver

  const stopObserving = () => {
    callback()
    observer.disconnect()
  }

  observer = new MutationObserver(mutations =>
    handleMutations(mutations, stopObserving)
  )

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  })
}

const isEnvValid = (
  pageType: PageType,
  productId: string,
  tenant: Tenant,
  deviceClass: string
): boolean => {
  return Boolean(
    pageType === PAGE_TYPE_PRODUCT &&
      window.dataLayer &&
      productId &&
      ![TENANT_BE].includes(tenant) &&
      !isDesktop(deviceClass)
  )
}

const pushAfBannerEvent = () => {
  window.dataLayer.push({ event: 'af_banner' })
}

export default () => {
  const { tenant, deviceClass } = store.getPublicRuntimeConfig().publicConfig
  const { pageType, productId = '' } =
    store.getPublicRuntimeConfig().pageProperties

  if (!isEnvValid(pageType, productId, tenant, deviceClass)) return

  observeBanner(() => pushAfBannerEvent())
  handleBannerEvents()
}
